class Security {
    constructor() {}

    HasAccess(VueStore, systemModule, type) {
        let retVal = true;
        let sessionData = VueStore.state.UserSessionData;
        //console.log("SESSION DATA?", sessionData)
        if (sessionData == null || sessionData.AccessToken == undefined) {
            return false;
        }

        if (sessionData.Role == undefined) {
           //console.error("[SECURITY] Role is undefined in session");
            return retVal;
        }

        if (sessionData.Role.Master == true) {
            retVal = true;
        } else if (sessionData.PermissionList != undefined && sessionData.PermissionList.length > 0) {
            let permissionResult = sessionData.PermissionList.filter((el) => el.SystemModuleCode.toUpperCase() == systemModule.toUpperCase());

            if (permissionResult.length == 0) {
                retVal = false;
            } else {
                switch (type.toUpperCase()) {
                    case "VIEW":
                        {
                            retVal = permissionResult[0].CanView;
                        }
                        break;
                    case "CREATE":
                        {
                            retVal = permissionResult[0].CanCreate;
                        }
                        break;
                    case "MODIFY":
                        {
                            retVal = permissionResult[0].CanModify;
                        }
                        break;
                    case "DELETE":
                        {
                            retVal = permissionResult[0].CanDelete;
                        }
                        break;
                    case "REPORT":
                        {
                            retVal = permissionResult[0].CanReport;
                        }
                        break;
                    case "SUSPEND":
                        {
                            retVal = permissionResult[0].CanSuspend;
                        }
                        break;
                    case "AUTHORISE":
                        {
                            retVal = permissionResult[0].CanAuthorise;
                        }
                        break;
                    case "EXTEND":
                        {
                            retVal = permissionResult[0].CanExtend;
                        }
                        break;
                }
            }
        } else {
            console.error("[SECURITY] PermissionList is null or empty in session");
            retVal = false;
        }
        return retVal;
    }
}

export default {
    install(Vue, store) {
        let securityObj = new Security();

        Vue.prototype.HasAccess = (systemModule, type) => {
            return securityObj.HasAccess(store, systemModule, type);
        };
    }
}